var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNextmineFlourishGold = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "44 4 272 42",
    width: 544,
    height: 84,
    role: "img",
    "aria-label": "Oldmine floral flourish divider",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#cdbf9f",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180,16 C186,10 196,16 192,24 C200,21 202,33 192,33 C196,42 184,45 180,36 C176,45 164,42 168,33 C158,33 160,21 168,24 C164,16 174,10 180,16 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 25,
    r: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,25 C140,25 116,21 96,26 C70,32 50,24 56,14 C59,9 67,12 64,18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,26 C112,30 132,28 152,25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,25 C124,18 116,17 110,21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,25 C220,25 244,21 264,26 C290,32 310,24 304,14 C301,9 293,12 296,18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,26 C248,30 228,28 208,25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,25 C236,18 244,17 250,21"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNextmineFlourishGold);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nextmine-flourish-gold.7071f1e15a913af66a092cbd90531ceb.svg";